import { render, staticRenderFns } from "./SkuFields.vue?vue&type=template&id=a1c6ec0c&scoped=true"
import script from "./SkuFields.vue?vue&type=script&lang=js"
export * from "./SkuFields.vue?vue&type=script&lang=js"
import style0 from "./SkuFields.vue?vue&type=style&index=0&id=a1c6ec0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c6ec0c",
  null
  
)

export default component.exports